// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"2513fb4c","474":"5362d164"}[chunkId] + ".chunk.js";
};